<style lang="scss" scoped>
    .full-calendar-body {
        .weeks {
            display: flex;
            border-top:1px solid #e0e0e0;
            border-bottom:1px solid #e0e0e0;
            border-left:1px solid #e0e0e0;
            background-color: #ebeff2;

            .week {
                flex:1;
                text-align: center;
                border-right:1px solid #e0e0e0;
                padding: 10px 0;
                text-transform: uppercase;
            }
        }

        .dates {
            position:relative;

            .week-row {
                border-left:1px solid #e0e0e0;
                display: flex;

                .day-cell {
                    flex:1;
                    min-height: 150px;
                    max-height: 220px;
                    height: 10vw;
                    padding: 4px;
                    border-right: 1px solid #e0e0e0;
                    border-bottom: 1px solid #e0e0e0;

                    .day-number {
                        text-align: right;
                        margin: 0;
                    }

                    &.today {
                        background-color:#ebeff2;
                    }

                    &.not-cur-month .day-number {
                        color:rgba(0,0,0,.24);
                    }
                }
            }

            .dates-events {
                position:absolute;
                top:0;
                left:0;
                z-index:1;
                width: 100%;

                .events-week {
                    display: flex;

                    .events-day {
                        flex:1;
                        overflow: hidden;
                        min-height: 150px;
                        max-height: 220px;
                        height: 10vw;

                        .day-number {
                            text-align: right;
                            padding:4px 5px 4px 4px;
                            opacity: 0;
                            margin: 0;
                        }

                        &.not-cur-month .day-number {
                            color:rgba(0,0,0,.24);
                        }

                        .event-box .event-item {
                            cursor: pointer;
                            font-size: 11px;
                            color: #fff;
                            padding: 2px 4px;
                            border-radius: 2px;
                            white-space: nowrap;
                            overflow: hidden;
                            text-overflow: ellipsis;
                            text-align: left;
                            margin: 4px;

                            &.is-opacity {
                                opacity: 0;
                            }

                            &.pending {
                                background-color: #ffbd4a;
                            }

                            &.pending-late {
                                background-color: #f05050;
                            }

                            &.done {
                                background-color: #5fbeaa;
                            }

                            &.canceled {
                                background-color: #aaa;
                            }

                            &:active {
                                box-shadow: inset 0 3px 5px rgba(0, 0, 0, 0.125);
                            }
                        }

                        .more-link {
                            cursor: pointer;
                            font-size: 12px;
                            font-weight: 500;
                            color: #999;
                            padding: 0 4px;
                            margin: 0;
                        }
                    }
                }
            }

            .more-events {
                position:absolute;
                width: 260px;
                z-index: 2;
                border:1px solid #eee;
                box-shadow: 0 2px 6px rgba(0,0,0,.15);

                .more-header {
                    background-color:#36404a;
                    color: #fff;
                    padding:5px;
                    display: flex;
                    align-items: center;
                    font-size: 14px;

                    .title {
                        flex:1;
                    }

                    .close {
                        margin-right: 2px;
                        cursor: pointer;
                        font-size: 16px;
                        color: #fff;
                        text-shadow: none;
                        opacity: 1;
                        font-weight: normal;
                    }
                }

                .more-body {
                    overflow: hidden;
                    background-color: #fff;

                    .body-list{
                        max-height: 220px;
                        overflow: auto;
                        padding: 0;
                        background-color: #fff;
                        margin: 0;

                        .body-item {
                            cursor: pointer;
                            font-size: 12px;
                            color: rgba(0,0,0,.87);
                            padding: 6px 4px;
                            white-space: nowrap;
                            overflow: hidden;
                            text-overflow: ellipsis;

                            i.pending {
                                color: #ffbd4a;
                            }

                            i.pending-late {
                                color: #f05050;
                            }

                            i.done {
                                color: #5fbeaa ;
                            }

                            i.canceled {
                                color: #777;
                            }

                            &:nth-child(odd) {
                                background-color: #fff!important;
                            }

                            &:nth-child(even) {
                                background-color: #ebeff2!important;
                            }
                        }
                    }
                }
            }
        }
    }

    @media (max-width: 1000px) {
        .full-calendar-body {
            .dates {
                .week-row,
                .events-week,
                .events-week .events-day {
                    display: block!important;
                }

                .dates-events {
                    position: relative;

                    .events-week .events-day {
                        padding: 4px;
                        border: 1px solid #e0e0e0;
                        border-top: none;
                        min-height: 60px;
                        max-height: auto;
                        height: auto;
                        padding: 4px;

                        &.today {
                            background-color: #ebeff2;
                        }

                        .day-number {
                            opacity: 1;
                            padding: 0;
                        }
                    }
                }
            }

            .weeks,
            .dates .week-row .day-cell,
            .day-cell.not-cur-month,
            .events-week .events-day.not-cur-month {
                display: none!important;
            }
        }
    }
</style>

<template>
    <div class="full-calendar-body">
        <div class="weeks">
            <strong class="week" v-for="week in weekNames">{{week}}</strong>
        </div>
        <div class="dates" ref="dates">
            <div class="dates-bg">
                <div class="week-row" v-for="week in currentDates">
                    <div class="day-cell" v-for="day in week" :class="{'today' : day.isToday, 'not-cur-month' : !day.isCurMonth}">
                        <p class="day-number">{{day.monthDay}}</p>
                    </div>
                </div>
            </div>
            <!-- absolute so we can make dynamic td -->
            <div class="dates-events">
                <div class="events-week" v-for="week in currentDates">
                    <div class="events-day" v-for="day in week" track-by="$index" :class="{'today' : day.isToday, 'not-cur-month' : !day.isCurMonth}" @click.stop="dayClick(day.date, $event)">
                        <p class="day-number">{{day.monthDay}}</p>
                        <div class="event-box">
                            <p class="event-item" v-for="event in day.events" v-show="event.cellIndex <= eventLimit" :class="[classNames(event.cssClass), getStatusClass(event), {
                                'is-start'   : isStart(event.start, day.date),
                                'is-end'     : isEnd(event.end,day.date),
                                'is-opacity' : !event.isShow
                                }]"
                                @click="eventClick(event,$event)" v-pml-popover="event.title">
                                {{ isBegin(event, day.date, day.weekDay) }}
                            </p>
                            <p v-if="day.events.length > eventLimit"
                               class="more-link" @click.stop="selectThisDay(day, $event)">
                                + {{ day.events[day.events.length -1].cellIndex - eventLimit}} {{ $t('more') }}
                            </p>
                        </div>
                    </div>
                </div>
            </div>

            <!-- full events when click show more -->
            <div class="more-events" v-show="showMore"
                 :style="{left: morePos.left + 'px', top: morePos.top + 'px'}">
                <div class="more-header">
                    <span class="title">{{moreTitle(selectDay.date)}}</span>
                    <span class="close" @click.stop="showMore = false">x</span>
                </div>
                <div class="more-body">
                    <ul class="body-list">
                        <li v-for="event in selectDay.events"
                            v-show="event.isShow" class="body-item"
                            @click="eventClick(event,$event)"
                            v-pml-popover="event.title">
                            <i class="fa fa-circle" :class="getStatusClass(event)"></i>
                            <span>{{ formattedTitle(event) }}</span>
                        </li>
                    </ul>
                </div>
            </div>
            <slot name="body-card"></slot>
        </div>
    </div>
</template>

<script>
    import dateFunc from './dateFunc'
    import moment from 'moment'
    import { isNil } from 'lodash'

    export default {
        props: {
            currentDate: {},
            events: {},
            weekNames: {
                type: Array,
                default: []
            },
            monthNames: {},
            firstDay: {}
        },
        data () {
            return {
                weekMask: [1, 2, 3, 4, 5, 6, 7],
                isLismit: true,
                eventLimit: 3,
                showMore: false,
                morePos: {
                    top: 0,
                    left: 0
                },
                selectDay: {}
            }
        },
        computed: {
            currentDates () {
                return this.getCalendar()
            }
        },
        methods: {
            formattedTitle (event) {
                return `${moment(event.start, 'YYYY-MM-DD HH:mm:ss').format('HH[:]mm')} - ${event.deal.lead.full_name}`
            },
            isBegin (event, date, index) {
                let st = new Date(event.start)

                return (index === 0 || st.toDateString() === date.toDateString()) ? this.formattedTitle(event) : ''
            },
            moreTitle (date) {
                let dt = new Date(date)
                return this.weekNames[dt.getDay()] + ', ' + this.monthNames[dt.getMonth()] + ' ' + dt.getDate()
            },
            classNames (cssClass) {
                if (!cssClass) return ''
                // string
                if (typeof cssClass === 'string') return cssClass

                // Array
                if (Array.isArray(cssClass)) return cssClass.join(' ')

                // else
                return ''
            },
            getStatusClass (event) {
                if (event.status !== 'pending')
                    return event.status

                if (moment().diff(moment(event.start, 'YYYY-MM-DD HH:mm:ss'), 'hours', true) > 0)
                    return 'pending-late'

                return 'pending'
            },
            getCalendar () {
                // calculate 2d-array of each month
                // first day of this month
                let now = new Date() // today
                let current = new Date(this.currentDate)

                let startDate = dateFunc.getStartDate(current) // 1st day of this month

                let curWeekDay = startDate.getDay()

                // begin date of this table may be some day of last month
                let diff = parseInt(this.firstDay) - curWeekDay
                diff = diff > 0 ? (diff - 7) : diff

                startDate.setDate(startDate.getDate() + diff)
                let calendar = []

                for (let perWeek = 0; perWeek < 6; perWeek++) {
                    let week = []

                    for (let perDay = 0; perDay < 7; perDay++) {
                        week.push({
                            monthDay: startDate.getDate(),
                            isToday: now.toDateString() === startDate.toDateString(),
                            isCurMonth: startDate.getMonth() === current.getMonth(),
                            weekDay: perDay,
                            date: new Date(startDate),
                            events: this.slotEvents(startDate)
                        })
                        startDate.setDate(startDate.getDate() + 1)
                    }
                    calendar.push(week)
                }
                return calendar
            },
            slotEvents (date) {
                // reset date by discarding hour and old time zone
                date = new Date(date.getFullYear(), date.getMonth(), date.getDate())
                let thisDayEvents = this.events.filter(day => {
                    let dt = new Date(day.start)
                    let st = new Date(dt.getFullYear(), dt.getMonth(), dt.getDate())
                    let ed = day.end ? new Date(day.end) : st
                    return date >= st && date <= ed
                })

                // mark cellIndex and place holder
                for (let i = 0; i < thisDayEvents.length; i++) {
                    thisDayEvents[i].cellIndex = i + 1
                    thisDayEvents[i].isShow = true
                    if (thisDayEvents[i].cellIndex === i + 1 || i > 2) continue
                    thisDayEvents.splice(i, 0, {
                        title: 'holder',
                        cellIndex: i + 1,
                        start: dateFunc.format(date, 'yyyy-MM-dd'),
                        end: dateFunc.format(date, 'yyyy-MM-dd'),
                        isShow: false
                    })
                }

                return thisDayEvents
            },
            isStart (eventDate, date) {
                let st = new Date(eventDate)
                return st.toDateString() === date.toDateString()
            },
            isEnd (eventDate, date) {
                let ed = new Date(eventDate)
                return ed.toDateString() === date.toDateString()
            },
            selectThisDay (day, jsEvent) {
                this.selectDay = day
                this.showMore = true
                this.morePos = this.computePos(jsEvent.target)
                this.morePos.top -= 100
                let events = day.events.filter(item => {
                    return item.isShow === true
                })
                this.$emit('moreclick', day.date, events, jsEvent)
            },
            computePos (target) {
                let eventRect = target.getBoundingClientRect()
                let pageRect = !isNil(this.$refs.dates) ? this.$refs.dates.getBoundingClientRect() : {left: 0, top: 0}

                return {
                    left: eventRect.left - pageRect.left,
                    top: eventRect.top + eventRect.height - pageRect.top
                }
            },
            dayClick (day, jsEvent) {
                this.$emit('dayclick', day, jsEvent)
            },
            eventClick (event, jsEvent) {
                if (!event.isShow) return
                jsEvent.stopPropagation()
                let pos = this.computePos(jsEvent.target)
                this.$emit('eventclick', event, jsEvent, pos)
            }
        }
    }
</script>



// WEBPACK FOOTER //
// src/components/helpers/full_calendar/Body.vue